let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fuCcq")).then(() => parcelRequire('Ggc9Q'));